module.exports = __webpack_public_path__ + "static/media/Lykke03.b1911f43.jpg";